import {
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Button,
} from 'react-bootstrap';
import React from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../context';
import { toast } from 'react-toastify';

const Login = () => {
  const { userInfo, setUserInfo, setScore, setLessonState } =
    useGlobalContext();

  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(
        'https://jap-vocab-n2.herokuapp.com/api/v1/users/login',
        {
          email: email,
          password: password,
        }
      );
      const user = await axios.get(
        `https://jap-vocab-n2.herokuapp.com/api/v1/users/${email}`
      );
      // console.log(user.data.name);
      setUserInfo({
        name: user.data.name,
        _id: user.data._id,
        score: user.data.score,
        lessons: user.data.lessons,
      });

      setScore(user.data.score);
      setLessonState(user.data.lessons);
      if (localStorage.getItem('score')) {
        localStorage.removeItem('score');
      }
      if (localStorage.getItem('lessons')) {
        localStorage.removeItem('lessons');
      }
      // console.log(user.data);
      localStorage.setItem('score', JSON.stringify(user.data.score));
      localStorage.setItem('lessons', JSON.stringify(user.data.lessons));
      localStorage.setItem('userInfo', JSON.stringify(user.data));
      setLoading(false);
      // console.log(user);
      //  console.log('login page: ' + userInfo);
      navigate('/');
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };
  if (loading) {
    return <div>LOADING...</div>;
  }

  return (
    <div
      className="flex"
      style={{
        flexDirection: 'column',
        gap: '2rem',
        marginTop: '20px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Form onSubmit={submitHandler}>
        <FormGroup>
          <FormLabel>Email: </FormLabel>
          <FormControl
            type="text"
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Password: </FormLabel>
          <FormControl
            type="password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormGroup>
        <Button type="submit" style={{ width: '100%', marginTop: '20px' }}>
          Login
        </Button>
        {!userInfo && (
          <Link to="/signup">
            <Button style={{ width: '100%', marginTop: '20px' }}>
              Sign Up
            </Button>
          </Link>
        )}
      </Form>{' '}
    </div>
  );
};

export default Login;
